(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input[name="quantity"], input[data-qty-input]');
    if (!input) return;
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var next = (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty-step'), 10);
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (input) {
      var form = input.closest('form');
      if (form) form.submit();
      return;
    }
    var picker = e.target.closest('[data-variant-picker]');
    if (picker) {
      var root = picker.closest('[data-product-root]');
      var selects = root.querySelectorAll('[data-variant-picker]');
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; }).join(' / ');
      var variants = JSON.parse(root.querySelector('[data-variant-json]').textContent);
      var match = variants.filter(function (v) { return v.title === chosen; })[0];
      var idInput = root.querySelector('[name="id"]');
      var priceEl = root.querySelector('[data-variant-price]');
      var stockEl = root.querySelector('[data-variant-stock]');
      var addBtn = root.querySelector('[data-add-button]');
      if (match) {
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = match.price;
        if (stockEl) {
          stockEl.textContent = match.available ? stockEl.getAttribute('data-in') : stockEl.getAttribute('data-out');
          stockEl.classList.toggle('product__stock--out', !match.available);
        }
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? addBtn.getAttribute('data-label') : addBtn.getAttribute('data-sold-out');
        }
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
      }
    }
  });

  var searchInput = document.querySelector('[data-predictive-input]');
  var results = document.querySelector('[data-predictive-results]');
  if (searchInput && results) {
    var timer = null;
    var run = function () {
      var q = searchInput.value.trim();
      if (q.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
      fetch('/search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&section_id=predictive-search')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('[data-predictive-inner]');
          results.innerHTML = inner ? inner.innerHTML : '';
          results.hidden = false;
        })
        .catch(function () { results.hidden = true; });
    };
    searchInput.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 220); });
    searchInput.addEventListener('focus', run);
    document.addEventListener('click', function (e) {
      if (!results.contains(e.target) && e.target !== searchInput) results.hidden = true;
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') results.hidden = true; });
  }
})();
